import axiosInstance from "../../../../axios";

// Get permission
export const getManagePermissionService = async (payload) => {
  try {
    const response = await axiosInstance.get(`/level/level-with-access`);
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

//Post Level
export const addNewLevelService = async (payload) => {
  try {
    const response = await axiosInstance.post(`/level`, payload);
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};
